var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-layout",
    { attrs: { "md-column": "" } },
    [
      _c(
        "router-link",
        { attrs: { to: { name: "CreateDomainList" } } },
        [
          _c(
            "md-button",
            {
              staticClass: "md-fab md-fab-bottom-right md-icon-button",
              attrs: { id: "btn-add-domain", "md-theme": "blue" }
            },
            [_c("md-icon", { attrs: { "md-iconset": "fa fa-plus" } })],
            1
          )
        ],
        1
      ),
      _c(
        "md-theme",
        { attrs: { "md-name": "blue" } },
        [
          _c("breadcrumbs", {
            attrs: { section: "Domain Lists", nav: _vm.nav }
          }),
          _c("domain-table", { attrs: { id: "domains" } })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-57db69ce", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57db69ce","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/spa/domain/DomainList.vue
// module id = 840
// module chunks = 0